import { AnyAction } from 'redux'
import * as type from '@app/constants/myEnergy/billingPeriod'

export interface IBillingPeriodState {
  isSetUpPeriodPopupOpen: boolean,
  isBillingPeriodsStatsPopupOpen: boolean,
}

export const initialState: IBillingPeriodState = {
  isSetUpPeriodPopupOpen: false,
  isBillingPeriodsStatsPopupOpen: false,
}

const billingPeriod = (
  state: IBillingPeriodState = initialState,
  action: AnyAction,
): IBillingPeriodState => {
  switch (action.type) {
  case type.SET_UP_BILLING_PERIOD_OPEN: {
    return {
      ...state,
      isSetUpPeriodPopupOpen: true,
    }
  }
  case type.SET_UP_BILLING_PERIOD_CLOSE: {
    return {
      ...state,
      isSetUpPeriodPopupOpen: false,
    }
  }
  case type.BILLING_PERIODS_STATS_POPUP_OPEN: {
    return {
      ...state,
      isBillingPeriodsStatsPopupOpen: true,
    }
  }
  case type.BILLING_PERIODS_STATS_POPUP_CLOSE: {
    return {
      ...state,
      isBillingPeriodsStatsPopupOpen: false,
    }
  }
  default:
    return state
  }
}

export default billingPeriod
